export default __webpack_public_path__ + "static/media/Logo2.6cdf8b5f.png";